<template>
  <div class="location-summary">
    <h3 class="global-h3 location-summary__title">
      <IconEmbedded name="map-pin_2-5" :size="20" style="margin-right: 4px" />
      {{ location.title }}
    </h3>

    <p v-if="location.summaryByCreator" class="location-summary__description">
      {{ location.summaryByCreator }}
    </p>

    <HighlightsSection v-if="location.mediaIds?.length" class="location-summary__highlights" :highlightAssetIds="location.mediaIds" :visibleLines="200" :stretchToFill="false" />
  </div>
</template>

<script setup lang="ts">
import { CollabAdventureLocationSummary } from "@contracts/collabLocations";

// Components
import HighlightsSection from "@components/HighlightsSection.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

defineProps<{
  location: CollabAdventureLocationSummary;
}>();
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

.location-summary {
  &__title {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }

  &__description {
    white-space: pre-wrap;
    margin-bottom: 12px;
    margin-right: 70px;
    color: rgba(0, 0, 0, 0.7);
  }

  @media (max-width: $mobile-max-width) {
    &__description {
      margin-right: 20px;
    }
  }
  @media (min-width: $mobile-max-width) and (max-width: $tablet-max-width) {
    &__description {
      margin-right: 40px;
    }
  }
}
</style>
